<template>
    <div>
        <CRow style="margin-top: 24px;margin-bottom: 36px;">
            <CCol sm="10">
                <h4 class="font-weight-bold">Import Shift</h4>
            </CCol>
            <CCol v-if="dataTable != null" sm="2">
                <CButton @click="saveImport()" type="button" class="btn btn-add">
                    <span v-if="loading == false">Simpan</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="2">
                <CButton @click="downloadTemplate()" type="button" class="btn btn-add">Template</CButton>
            </CCol>
            <CCol sm="2">
                <CButton type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-add">
                    <span v-if="loadingUpload == false"><font-awesome-icon class="mr-2" :icon="{prefix: 'fas', iconName: 'upload'}" />Import Excel</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
                <input type="file" accept=".xls, .xlsx" @change="loadFile()" style="display:none" ref="inputsFile" id="inputFile" class="hide" />
            </CCol>
        </CRow>
        <CRow class="mt-4" v-if="dataTable != null">
            <CCol sm="12">
                <Tables @edit="editData" :data="dataTable" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
                <PopUpImport ref="popUpImport"/>
            </CCol>
        </CRow>
    </div>
</template>
<script>
import Tables from '../../../component/tableShiftNew'
import { DataApi } from '../../../service/DataApi'
import PopUpImport from './PopUpImport'
import axios from 'axios'

export default {
    components: {
        Tables,
        PopUpImport
    },
    data() {
        return {
            loading: false,
            loadingUpload: false,
            dataTable: null,
            dataTh: [
                'Nama',
                'NIP',
                'Total Jadwal',
                'Total Jadwal Sukses',
                'Total Jadwal Error',
                'Action'
            ],
            dataTd: [
                'nama',
                'nip',
                'totalJadwal',
                'totalSuccess',
                'totalError',
                'action'
            ],
            styleTable: ['100px', '100px', '100px', '100px', '100px', '100px'],
            errorMessage: '',
        }
    },
    methods: {
        clearData() {
            this.dataTable = null
            this.loading = false
            this.loadingUpload = false
            this.$refs.inputsFile.value = null
        },
        downloadTemplate() {
            // window.open('https://api-ioffice.air.id/cdn/load/xlsx/d4dd95b')
            // let payload = "xlsx/d4dd95b"
            axios.post("https://api-ioffice.air.id/cdn/load/xlsx/d4dd95b", {responseType: 'blob'})
            .then(res => {
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Template format Shifting')
                document.body.appendChild(link)
                link.click()
            })
        },
        loadFile() {
            this.loadingUpload = true

            const fileImport = document.getElementById('inputFile').files[0];

            const formData = new FormData();
            formData.append("file", fileImport)
            DataApi.post("import/shift/preview", formData)
            .then(res => {
                let temp = res.data
                if(temp.success == true) {
                    this.dataTable = []
                    temp.data.forEach( e => {
                        let onPush = {
                            nama: e.nama,
                            nip: e.nip,
                            totalJadwal: e.jadwal.length,
                            detailJadwal: e.jadwal,
                            totalError: e.totalError,
                            totalSuccess: e.totalSuccess
                        }
                        this.dataTable.push(onPush)
                    })
                } else {
                    alert(temp.message)
                    this.dataTable = null
                }
            })
            this.loadingUpload = false
        },
        editData(value) {
            let dt = this.dataTable[value]
            this.$refs.popUpImport.data = dt
            this.$refs.popUpImport.isShown = true
        },
        saveImport() {
            this.loading = true
            let payload = []
            this.dataTable.forEach( e => {
                let onPush = {
                    jadwal: e.detailJadwal,
                    nama: e.nama,
                    nip: e.nip,
                    totalError: e.totalError,
                    totalSuccess: e.totalSuccess
                }
                payload.push(onPush)
            })
            DataApi.post('import/shift/submit', payload)
            .then( res => {
                let response = res.data
                let success = ''
                let alertMess = ''
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        success = true
                    } else {
                        success = false
                    }
                    alertMess = response.data.Data2
                } else {
                    alertMess = response.message
                    success = false
                }
                let onPush = {
                    mess: alertMess,
                    succ: success
                }
                this.$emit('backFront', onPush)
                this.clearData()
            })
        }
    },
}
</script>

<style scoped>
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}</style>